<template>
  <div
    class="manager_box"
    style="padding: 14px; box-sizing: border-box"
    v-loading="loading"
  >
    <!-- <el-select v-model="Pie_chart_value" placeholder="请选择" v-if='jurisdiction && $cookies.get("auth_grade") == 100' @change="handleClick">
          <el-option :key="super_options.staff_id" :label="super_options.realname" :value="super_options.staff_id"></el-option>
          <el-option-group v-for="group in options" :key="group.name" :label="group.name">
            <el-option v-for="item in group.value" :key="item.staff_id" :label="item.realname" :value="item.staff_id">
            </el-option>
          </el-option-group>
    </el-select>-->

    <el-cascader
      v-model="Pie_chart_value_fu"
      :options="options"
      :props="{ label: 'realname', value: 'staff_id', children: 'value' }"
      @change="handleChange"
      v-if="jurisdiction && $cookies.get('auth_grade') == 100"
    ></el-cascader>

    <el-select
      v-model="Pie_chart_value"
      placeholder="请选择"
      v-else-if="jurisdiction && $cookies.get('auth_grade') == 30"
      @change="handleClick"
    >
      <el-option
        v-for="item in options"
        :key="item.staff_id"
        :label="item.realname"
        :value="item.staff_id"
      ></el-option>
    </el-select>
    <el-select
      v-model="Pie_chart_value"
      placeholder="请选择"
      v-else-if="jurisdiction && $cookies.get('auth_grade') == 80"
      @change="handleClick"
    >
      <el-option
        v-for="item in options"
        :key="item.staff_id"
        :label="item.realname"
        :value="item.staff_id"
      ></el-option>
    </el-select>
    <div>
      <div class="manager_cenetr">
        <div
          class="item_range_index"
          v-if="
            ($cookies.get('product_name') == '渠道' ||
              $cookies.get('auth_grade') == 100) &&
            is_show_yibiaopan
          "
        >
          <div class="data_overview">
            <el-date-picker
              v-model="value2"
              type="month"
              placeholder="选择月"
              @change="achievement"
              value-format="yyyy-M"
            ></el-date-picker>
            <div class="data_overview_title">总业绩</div>
          </div>
          <!-- <el-date-picker v-model="performance_time" type="month" placeholder="选择月"></el-date-picker> -->
          <div
            v-loading="myChart_loading"
            class="Icon_div"
            id="myChart_Z"
            :style="{ width: '300px', height: '300px' }"
          ></div>
          <div class="bottom_message">
            目标数：{{ agent_Z.target_money }},完成率：{{ agent_Z.percentage }}%
          </div>
        </div>
        <div
          class="item_range_index"
          v-if="
            ($cookies.get('product_name') == '渠道' ||
              $cookies.get('auth_grade') == 100) &&
            is_show_yibiaopan
          "
        >
          <div class="data_overview">
            <el-date-picker
              v-model="value2"
              type="month"
              placeholder="选择月"
              @change="achievementZ"
              value-format="yyyy-M"
            ></el-date-picker>
            <div class="data_overview_title">代理商</div>
          </div>
          <!-- <el-date-picker v-model="performance_time" type="month" placeholder="选择月"></el-date-picker> -->
          <div
            v-loading="myChart_loading"
            class="Icon_div"
            id="myChart_agent"
            :style="{ width: '300px', height: '300px' }"
          ></div>
          <div class="bottom_message">
            目标数：{{ agent_data.target_money }},完成率：{{
              myChart_data.percentage
            }}%
          </div>
        </div>
        <div class="item_range_index">
          <div class="data_overview">
            <el-date-picker
              v-model="value2"
              type="month"
              placeholder="选择月"
              @change="achievementAgent"
              value-format="yyyy-M"
            ></el-date-picker>
            <div class="data_overview_title">
              {{ is_show_yibiaopan ? "开拓业绩" : "业绩" }}
            </div>
          </div>
          <!-- <el-date-picker v-model="performance_time" type="month" placeholder="选择月"></el-date-picker> -->
          <div
            v-loading="myChart_loading"
            class="Icon_div"
            id="myChart"
            :style="{ width: '300px', height: '300px' }"
          ></div>
          <div class="bottom_message">
            目标数：{{ myChart_data.target_money }},完成率：{{
              myChart_data.percentage
            }}%
          </div>
        </div>
        <div
          class="item_range_index"
          v-if="$cookies.get('product_name') == '渠道'"
        >
          <div class="data_overview">
            <el-date-picker
              v-model="value2"
              type="month"
              placeholder="选择月"
              @change="achievementAgent"
              value-format="yyyy-M"
            ></el-date-picker>
            <div class="data_overview_title">
              {{ "充值" }}
            </div>
          </div>
          <!-- <el-date-picker v-model="performance_time" type="month" placeholder="选择月"></el-date-picker> -->
          <div
            v-loading="myChart_loading"
            class="Icon_div"
            id="myChart_pay"
            :style="{ width: '300px', height: '300px' }"
          ></div>
          <div class="bottom_message">
            目标数：{{ pay_data.target_money }},完成率：{{
              pay_data.percentage
            }}%
          </div>
        </div>
        <div class="item_range_index">
          <div class="data_overview">
            <div class="data_overview_title">ABCD类客户数</div>
          </div>
          <div
            class="Icon_div"
            v-loading="Pie_chart_loading"
            id="Pie_chart"
            :style="{ width: '300px', height: '300px' }"
          ></div>
          <div class="bottom_message">
            A:
            <span>{{ Pie_chart_data[0].value }}</span
            >&nbsp;&nbsp;B: <span>{{ Pie_chart_data[1].value }}</span
            >&nbsp;&nbsp;C: <span>{{ Pie_chart_data[2].value }}</span
            >&nbsp;&nbsp;D:
            <span>{{ Pie_chart_data[3].value }}</span>
          </div>
        </div>
        <div class="item_range_index">
          <div class="data_overview">
            <div class="data_overview_title">销售流程状态</div>
          </div>
          <div
            class="Icon_div"
            v-loading="Line_loading"
            id="Funnel"
            :style="{ width: '300px', height: '300px' }"
          ></div>
          <div class="bottom_message">
            <span v-for="(item, index) in sales_process_status" :key="index">
              {{ item.name }}: {{ item.funnel }} &nbsp;&nbsp;
              <p v-if="index == 2"></p>
            </span>
          </div>
        </div>
        <!-- <div class="item_range_index">
          <div class="data_overview">
            <div class="data_overview_title">销售走势图</div>
          </div>
          <div
            class="Icon_div"
            v-loading="broken_line_loading"
            id="total_Line_chart"
            :style="{ width: '300px', height: '300px' }"
          ></div>
        </div>-->
      </div>
      <div class="data_overview">
        <div class="data_overview_title">销售流程状态</div>
      </div>
      <div class="for_map">
        <div
          class="item_range_index"
          v-for="(item, index) in sales_process_status"
          :key="index"
        >
          <div class="data_map" v-loading="Line_loading">
            <p>{{ item.name }}</p>
            <div style="font-size: 30px">{{ item.today }}</div>
            <div class="shujv_span">
              <div>较昨天</div>
              <div
                :style="{
                  color:
                    item.today - item.yesterday < 0
                      ? '#41b833'
                      : item.today - item.yesterday == 0
                      ? '#1296db'
                      : '#d81e06',
                }"
              >
                {{ item.today - item.yesterday }}
                <span
                  class="iconfont"
                  :class="[
                    item.today - item.yesterday < 0
                      ? 'iconxiajiang-copy'
                      : item.today - item.yesterday == 0
                      ? 'iconchiping'
                      : 'icondiag_up',
                  ]"
                ></span>
              </div>
            </div>
            <div class="line_chart" :id="'Line' + index"></div>
          </div>
        </div>
      </div>
      <div class="data_overview">
        <div class="data_overview_title">当日数据</div>
      </div>
      <div class="for_map">
        <div
          class="item_range_index"
          v-for="(item, index) in every_day"
          :key="index"
        >
          <div class="data_map" v-loading="every_day_loading">
            <p>{{ item.name }}</p>
            <div style="font-size: 30px">{{ item.today }}</div>
            <div class="shujv_span">
              <div>较昨天</div>
              <div
                :style="{
                  color:
                    item.today - item.yesterday < 0
                      ? '#41b833'
                      : item.today - item.yesterday == 0
                      ? '#1296db'
                      : '#d81e06',
                }"
              >
                {{ item.today - item.yesterday }}
                <span
                  class="iconfont"
                  :class="[
                    item.today - item.yesterday < 0
                      ? 'iconxiajiang-copy'
                      : item.today - item.yesterday == 0
                      ? 'iconchiping'
                      : 'icondiag_up',
                  ]"
                ></span>
              </div>
            </div>
            <div class="line_chart" :id="'every_day' + index"></div>
          </div>
        </div>
        <div class="item_range_index">
          <div class="data_overview">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="telephone_volume"
              value-format="timestamp"
            ></el-date-picker>
            <div class="data_overview_title">基础工作电话情况</div>
          </div>
          <div
            class="Icon_div"
            v-loading="telephone_calls_loading"
            id="telephone_calls"
            :style="{ width: '300px', height: '300px' }"
          ></div>
        </div>
      </div>

      <div class="data_overview">
        <div class="data_overview_title">明日跟进客户</div>
      </div>
      <div class="item_range_index" style="width: 400px">
        <div class="data_map" v-loading="every_day_loading">
          <div
            class="Icon_div"
            v-loading="follow_data_loading"
            id="tomorrow_s_data"
            :style="{ width: '300px', height: '300px' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      jurisdiction: false,

      performance_time: "", // 业绩本月时间

      Pie_chart_value: "", // 职员列表
      Pie_chart_value_fu: [],
      cascader_value: [],

      Pie_chart_value_value: "",
      options: [], // 职员列表
      super_options: {},

      loading: false,
      myChart_loading: false,
      Pie_chart_loading: false,
      broken_line_loading: false,
      telephone_calls_loading: false,
      // funnel_loading: false,
      Line_loading: false,
      every_day_loading: false,
      follow_data_loading: false,

      dropdown_item: "本月", // 下拉菜单的内容
      dropdown_item_id: "0", // 下拉菜单的内容ID
      value2: "", // 本月/上个月
      value1: [],

      // 仪表盘数据
      myChart_data: {
        value: "0.00",
        percentage: 0,
        target_money: 0,
        finish_money: 0,
        name: "完成金额",
      }, // 仪表盘data
      Pie_chart_data: [
        { name: "A类型", value: 0 },
        { name: "B类型", value: 0 },
        { name: "C类型", value: 0 },
        { name: "D类型", value: 0 },
      ], // 饼状图data
      Trend_chart_data: {
        this_month_data: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0,
        ],
      },
      telephone_calls_data: [
        {
          name: "Apples",
          value: 70,
        },
        {
          name: "Strawberries",
          value: 68,
        },
        {
          name: "Bananas",
          value: 48,
        },
        {
          name: "Oranges",
          value: 40,
        },
        {
          name: "Pears",
          value: 32,
        },
        {
          name: "Pineapples",
          value: 27,
        },
        {
          name: "Grapes",
          value: 18,
        },
      ],
      sales_process_status: [
        {
          name: "新客户",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "添加微信",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "产品演示",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "电子合同",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "已签未回",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "完成",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
      ], // 销售流程状态下的客户
      every_day: [
        {
          name: "新增客户",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "接通量",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "今日回访",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
      ], // 每人每天数据
      follow_data: [
        { name: "A类型", value: 0 },
        { name: "B类型", value: 0 },
        { name: "C类型", value: 0 },
        { name: "D类型", value: 0 },
      ],

      achievement_item: "",
      whole_myChart_data: {
        value: "0.00",
        target_money: 0,
        finish_money: 0,
        name: "完成金额",
      }, // 仪表盘data
      whole_Pie_chart_data: [
        { name: "A类型", value: 0 },
        { name: "B类型", value: 0 },
        { name: "C类型", value: 0 },
        { name: "D类型", value: 0 },
      ], // 饼状图data
      whole_sales_process_status: [
        {
          name: "新客户",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "添加微信",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "产品演示",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "电子合同",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "已签未回",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "完成",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
      ], // 销售流程状态下的客户
      whole_every_day: [
        {
          name: "新增客户",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "接通量",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
        {
          name: "今日回访",
          sevenday: [0, 0, 0, 0, 0, 0, 0],
          today: 0,
          yesterday: 0,
        },
      ], // 每人每天数据
      whole_Trend_chart_data: {
        best_month_data: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0,
        ],
        last_month_data: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0,
        ],
        this_month_data: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0,
        ],
      },
      agent_data: {},
      pay_data: {},
      agent_Z: {},
      value2Z: "",
      value2Z: "",
      value2_agent: "",
      is_show_yibiaopan: false,
    };
  },
  created() {
    console.log("权限aaaaaaaaaa", this.Pie_chart_value_fu[0]);
    if (
      this.$cookies.get("staff_id").split(",")[0] == "渠道" ||
      this.$cookies.get("staff_id").split(",")[0] == "S7A40A0BC9" ||
      this.$cookies.get("product_name") == "渠道"
    ) {
      this.is_show_yibiaopan = true;
    }

    if (this.$cookies.get("auth_grade") != 20) {
      this.jurisdiction = true;
      this.staff_member_list(); // 职员列表
    } else {
      this.require_ech();
    }
  },
  mounted() {
    // this.myChart();
    // this.columnar();
    // this.Funnel()
    // this.Pie_chart();
    // this.Line();
  },
  methods: {
    achievement(e) {
      console.log("当前选择时间", e);
      if (e != null) {
        this.sale_data_show();
      } else {
        this.value2 = "";
        this.sale_data_show();
      }
    },
    achievementZ(e) {
      console.log("当前选择时间", e);
      if (e != null) {
        this.sale_data_show();
      } else {
        this.value2Z = "";
        this.sale_data_show();
      }
    },
    achievementAgent(e) {
      console.log("当前选择时间", e);
      if (e != null) {
        this.sale_data_show();
      } else {
        this.value2_agent = "";
        this.sale_data_show();
      }
    },
    telephone_volume(e) {
      console.log("当前选择时间", e);
      if (e != null) {
        this.telephone_calls();
      } else {
        this.value1 = [];
        this.telephone_calls();
      }
    },
    staff_member_list() {
      // 职员列表
      this.loading = true;
      require("POST", "/lufish_user/v1/lufish_staff/", {}).then((res) => {
        if (!res.code) {
          this.options = [];
          this.super_options = {};
          this.options = res.data;
          this.loading = false;
          console.log(
            "this.$cookies.get('staff_id')",
            this.$cookies.get("staff_id")
          );
          if (!this.$cookies.get("staff_id")) {
            this.$cookies.set("staff_id", res.data[0].staff_id);
            this.Pie_chart_value = res.data[0].staff_id;
            if (this.$cookies.get("auth_grade") == 100) {
              this.Pie_chart_value_fu[0] = res.data[0].staff_id;
            }
            this.require_ech();
          } else {
            let staff_id_split = this.$cookies.get("staff_id").split(",");
            console.log("staff_id_split", staff_id_split);
            if (this.$cookies.get("auth_grade") == 30) {
              this.Pie_chart_value = staff_id_split[0];
            } else {
              this.Pie_chart_value = staff_id_split[staff_id_split.length - 1];
              this.Pie_chart_value_fu = staff_id_split;
              console.log(
                "Pie_chart_value",
                this.Pie_chart_value,
                this.Pie_chart_value_fu
              );
            }
            this.require_ech();
          }
        } else {
          this.$message.error("职员列表获取失败");
        }
        // this.whole_require_ech()
      });
      // .catch(err=> {
      //     this.loading = false
      // })
    },
    performance_data() {
      this.loading = true;
      let Obj = {};
      if (this.jurisdiction) {
        if (this.$cookies.get("auth_grade") == 100) {
          Obj.staff_id =
            this.Pie_chart_value_fu[this.Pie_chart_value_fu.length - 1];
        } else {
          Obj.staff_id = this.Pie_chart_value;
        }
      }
      console.log("趋势图", Obj);
      require("POST", "/lufish_index_data/v1/performance_data/", Obj).then(
        (res) => {
          if (!res.code) {
            this.whole_Trend_chart_data = res.data;
          } else {
            this.$message.error("职员列表获取失败");
          }
          this.loading = false;
          this.all_exhibition();
        }
      );
    },
    sale_data_show() {
      // 仪表盘信息
      let Obj = {
        // this_month: this.dropdown_item_id,
      };
      if (this.value2 != "") {
        let add = this.value2.split("-");
        Obj.year = add[0];
        Obj.month = add[1];
      }
      console.log("仪表盘ID", this.Pie_chart_value);
      if (this.jurisdiction) {
        if (this.$cookies.get("auth_grade") == 100) {
          Obj.staff_id =
            this.Pie_chart_value_fu[this.Pie_chart_value_fu.length - 1];

          Obj.staff_id =
            this.Pie_chart_value_fu[this.Pie_chart_value_fu.length - 1];
        } else {
          Obj.staff_id = this.Pie_chart_value;
        }
      }
      this.myChart_loading = true;
      require("POST", "/lufish_index_data/v1/sale_data_show/", Obj).then(
        (res) => {
          res.data.name = "完成金额";
          if (!res.code) {
            this.myChart_data = res.data;
            this.agent_data = res.agent_data;
            this.pay_data = res.pay_data;
            this.agent_Z = res.all_data;
          } else if (res.code == 116) {
            this.myChart_data = {
              value: "0.00",
              target_money: 0,
              percentage: 0,
              finish_money: 0,
            };
          } else {
            this.$message.error(res.msg);
          }
          this.myChart_loading = false;
          let arrEle = ["myChart", "myChart_agent", "myChart_Z", "myChart_pay"];
          let arrColumnar = [
            this.myChart_data,
            this.agent_data,
            this.agent_Z,
            this.pay_data,
          ];

          for (let i = 0; i < 4; i++) {
            arrColumnar[i].ele = arrEle[i];
            this.columnar(arrColumnar[i]);
          }
        }
      );
    },
    client_sort_count() {
      // 获取abcd类数据
      let Obj = {};
      if (this.jurisdiction) {
        if (this.$cookies.get("auth_grade") == 100) {
          Obj.staff_id =
            this.Pie_chart_value_fu[this.Pie_chart_value_fu.length - 1];
        } else {
          Obj.staff_id = this.Pie_chart_value;
        }
      }
      this.Pie_chart_loading = true;
      require("POST", "/lufish_index_data/v1/client_sort_count/", Obj).then(
        (res) => {
          // console.log('内容', res)
          let that = this;
          if (!res.code) {
            this.Pie_chart_data = res.data;
          } else {
            this.$message.error(res.msg);
          }
          this.Pie_chart_loading = false;
          this.Pie_chart();
        }
      );
    },
    trend_broken_line() {
      // 走势折线图
      console.log("走势图");
      let Obj = {};
      if (this.jurisdiction) {
        if (this.$cookies.get("auth_grade") == 100) {
          Obj.staff_id =
            this.Pie_chart_value_fu[this.Pie_chart_value_fu.length - 1];
        } else {
          Obj.staff_id = this.Pie_chart_value;
        }
      }
      this.broken_line_loading = true;
      require("POST", "/lufish_index_data/v1/staff_performance_data/", Obj).then(
        (res) => {
          let that = this;
          if (!res.code) {
            console.log("走势图内容", res.data);
            this.Trend_chart_data = res.data;
          } else {
            this.$message.error(res.msg);
          }
          this.broken_line_loading = false;
          this.broken_line();
        }
      );
    },
    telephone_calls() {
      console.log("饼状图");
      let search_data = {};
      if (this.value1.length > 0) {
        search_data = {
          start_time: this.value1[0] / 1000,
          end_time: this.value1[1] / 1000,
        };
      }
      let Obj = {
        search_data,
      };
      if (this.jurisdiction) {
        if (this.$cookies.get("auth_grade") == 100) {
          Obj.staff_id =
            this.Pie_chart_value_fu[this.Pie_chart_value_fu.length - 1];
        } else {
          Obj.staff_id = this.Pie_chart_value;
        }
      }
      this.telephone_calls_loading = true;
      require("POST", "/lufish_index_data/v1/staff_com_status/", Obj).then(
        (res) => {
          let that = this;
          if (!res.code) {
            console.log("走势图内容", res.data);
            this.telephone_calls_data = res.data;
          } else {
            this.$message.error(res.msg);
          }
          this.telephone_calls_loading = false;
          this.telephone_calls_line();
        }
      );
    },
    process_status() {
      // 销售流程状态下的客户
      let Obj = {};
      if (this.jurisdiction) {
        if (this.$cookies.get("auth_grade") == 100) {
          Obj.staff_id =
            this.Pie_chart_value_fu[this.Pie_chart_value_fu.length - 1];
        } else {
          Obj.staff_id = this.Pie_chart_value;
        }
      }
      this.Line_loading = true;
      require("POST", "/lufish_index_data/v1/week_contrast/", Obj).then(
        (res) => {
          // console.log('内容', res)
          let that = this;
          if (!res.code) {
            this.sales_process_status = res.data;
          } else {
            this.$message.error(res.msg);
          }
          this.Line_loading = false;
          that.Funnel();
          that.Line();
        }
      );
    },
    per_person_per_day() {
      // 每人每天数据
      let Obj = {};
      if (this.jurisdiction) {
        if (this.$cookies.get("auth_grade") == 100) {
          Obj.staff_id =
            this.Pie_chart_value_fu[this.Pie_chart_value_fu.length - 1];
        } else {
          Obj.staff_id = this.Pie_chart_value;
        }
      }
      this.every_day_loading = true;
      require("POST", "/lufish_index_data/v1/com_status_contrast/", Obj).then(
        (res) => {
          // console.log('内容', res)
          let that = this;
          if (!res.code) {
            this.every_day = res.data;
          } else {
            this.$message.error(res.msg);
          }
          that.every_day_loading = false;
          that.myChart();
        }
      );
    },
    follow_data_re() {
      let Obj = {};
      if (this.jurisdiction) {
        if (this.$cookies.get("auth_grade") == 100) {
          Obj.staff_id =
            this.Pie_chart_value_fu[this.Pie_chart_value_fu.length - 1];
        } else {
          Obj.staff_id = this.Pie_chart_value;
        }
      }
      this.follow_data_loading = true;
      require("POST", "/lufish_index_data/v1/follow_data/", Obj).then((res) => {
        // console.log('内容', res)
        let that = this;
        if (!res.code) {
          this.follow_data = res.data;
        } else {
          this.$message.error(res.msg);
        }
        that.follow_data_loading = false;
        that.Tomorrow_s_data();
      });
    },
    abcd_class() {
      // 时间重选
      this.client_sort_count();
    },
    columnar(data) {
      // 绘制业绩仪表盘
      let that = this;
      let columnar = this.$echarts.init(document.getElementById(data.ele)); // 仪表盘
      columnar.setOption(
        {
          tooltip: {
            formatter: function (value) {
              return (
                value.seriesName +
                ": " +
                value.data.target_money +
                "<br/> 完成金额：" +
                value.data.finish_money +
                "(" +
                value.data.percentage +
                "%)"
              );
            },
          },
          series: [
            {
              splitNumber: 2, //刻度数量
              data: [data],
              axisLine: {
                //仪表盘轴线
                lineStyle: {
                  //轴线不同的颜色段
                  // color: [[0.2,'#00FFFF'],[0.8,'#3a80fa'],[1,'#ff0000']],
                  width: 20, //轴线宽度
                },
              },
              name: "业绩指标",
              max: data.target_money,
              type: "gauge",
              detail: {
                offsetCenter: ["0", "90"],
                formatter: function (val) {
                  // console.log('手册', val)
                  return data.finish_money;
                },
                // color: '#ffd805',
                fontSize: 30,
                fontWeight: "bold",
                //相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移
                // offsetCenter: [0, '75%']
              },
            },
          ],
        },
        true
      );
    },

    Pie_chart() {
      // ABCD类
      let that = this;
      let Pie_chart = this.$echarts.init(document.getElementById("Pie_chart")); // 柱状图
      Pie_chart.setOption({
        tooltip: {
          formatter: function (value) {
            return value.name + ": " + value.data;
          },
        },
        xAxis: {
          // show : false,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#bbb",
            },
          },
          // show: false,
          type: "value",
          // data: [
          //   this.Pie_chart_data[0].name,
          //   this.Pie_chart_data[1].name,
          //   this.Pie_chart_data[2].name,
          //   this.Pie_chart_data[3].name
          // ],
          // axisLabel: {
          //   show: true,
          //   textStyle: {
          //     color: "#bbb"
          //   }
          // }
        },
        yAxis: {
          type: "category",
          data: [
            // this.Pie_chart_data[0].name,
            // this.Pie_chart_data[1].name,
            // this.Pie_chart_data[2].name,
            // this.Pie_chart_data[3].name
            "A",
            "B",
            "C",
            "D",
          ],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#bbb",
            },
          },
        },
        color: "#6395F9",
        series: [
          {
            label: {
              normal: {
                show: true,
              },
            },
            data: [
              this.Pie_chart_data[0].value,
              this.Pie_chart_data[1].value,
              this.Pie_chart_data[2].value,
              this.Pie_chart_data[3].value,
            ],
            type: "bar",
            barWidth: 20, //柱图宽度
            showBackground: true,
            backgroundStyle: {
              color: "rgba(225, 225, 225, 0.9)",
              // color: 'black'
            },
            itemStyle: {
              //             normal: {
              // 　　　　　　　　//这里是重点
              //                 color: function(params) {
              //                     //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
              //                     var colorList = ['#a5e7f0', '#59c4e6', '#edafda', '#93b7e3'];
              //                     return colorList[params.dataIndex]
              //                 }
              //             }
            },
          },
        ],
      });
    },
    broken_line() {
      // ABCD类
      //
      let that = this;
      let broken_line = this.$echarts.init(
        document.getElementById("total_Line_chart")
      ); // 柱状图
      broken_line.setOption({
        // title: {
        //     text: '三十天的走势图'
        // },
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //     data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
        // },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
            20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
          ],
        },
        yAxis: {
          type: "value",
        },
        series: [
          // {
          //   name: "最佳",
          //   type: "line",
          //   stack: "总量",
          //   data: this.Trend_chart_data.best_month_data
          // },
          // {
          //   name: "上月",
          //   type: "line",
          //   stack: "总量",
          //   data: this.Trend_chart_data.last_month_data
          // },
          {
            name: "本月",
            type: "line",
            stack: "总量",
            data: this.Trend_chart_data.this_month_data,
          },
        ],
      });
    },
    telephone_calls_line() {
      let that = this;
      let telephone_calls = this.$echarts.init(
        document.getElementById("telephone_calls")
      ); // 饼状图
      telephone_calls.setOption({
        tooltip: {
          formatter: function (value) {
            return value.name + ": " + value.value;
          },
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: that.telephone_calls_data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    Funnel() {
      // 销售流程状态图
      let that = this;
      let data = [];
      this.sales_process_status.forEach((item) => {
        data.push({ name: item.name, value: item.funnel });
      });
      let Funnel = this.$echarts.init(document.getElementById("Funnel")); // 柱状图
      Funnel.setOption({
        tooltip: {
          trigger: "item",
          formatter: function (value) {
            // console.log(value)
            return value.name + ": " + value.data.value;
          },
        },

        series: [
          {
            name: "漏斗图",
            type: "funnel",
            left: "10%",
            top: 60,
            //x2: 80,
            bottom: 60,
            width: "80%",
            // height: {totalHeight} - y - y2,
            // min: 0,
            // max: 500,
            minSize: "0%",
            maxSize: "100%",
            sort: "descending",
            gap: 2,
            label: {
              show: true,
              position: "inside",
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            // itemStyle: {
            //     borderColor: '#fff',
            //     borderWidth: 1
            // },
            // emphasis: {
            //     label: {
            //         fontSize: 20
            //     }
            // },
            sort: "none",
            data: data,
          },
        ],
      });
    },
    Line() {
      // 销售流程状态
      let that = this;
      this.sales_process_status.forEach((item, index) => {
        let name = "Line" + index;
        window[name] = this.$echarts.init(
          document.getElementById("Line" + index + "")
        ); // 线状图
        window[name].setOption({
          xAxis: {
            show: false,
            boundaryGap: false,
            type: "category",
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            show: false,
            // type: 'value'
          },
          color: "#99CCFF",
          series: [
            {
              showSymbol: false,
              data: that.sales_process_status["" + index + ""].sevenday,
              type: "line",
              smooth: true,
              areaStyle: {},
            },
          ],
        });
      });
    },
    myChart() {
      // 每人每天图表
      let that = this;
      this.every_day.forEach((item, index) => {
        let name = "every_day" + index;
        window[name] = this.$echarts.init(
          document.getElementById("every_day" + index + "")
        ); // 线状图
        window[name].setOption({
          xAxis: {
            show: false,
            boundaryGap: false,
            type: "category",
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            show: false,
            // type: 'value'
          },
          color: "#99CCFF",
          series: [
            {
              showSymbol: false,
              data: that.every_day["" + index + ""].sevenday,
              type: "line",
              smooth: true,
              areaStyle: {},
            },
          ],
        });
      });
    },
    Tomorrow_s_data() {
      // 明日数据
      console.log("内容");
      let that = this;
      let tomorrow_s_data = this.$echarts.init(
        document.getElementById("tomorrow_s_data")
      ); // 业绩仪表图
      tomorrow_s_data.setOption({
        tooltip: {
          trigger: "item",
          formatter: function (value) {
            return value.name + ": " + value.data.value;
          },
        },
        legend: {
          type: "scroll",
          orient: "horizontal",
          right: 10,
          top: 20,
          bottom: 20,
        },
        series: [
          {
            name: "姓名",
            type: "pie",
            radius: "55%",
            center: ["40%", "50%"],
            data: that.follow_data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },

    all_employee_data() {
      // 全部数据
      let that = this;
      let all_instruments = this.$echarts.init(
        document.getElementById("myChart")
      ); // 业绩仪表图
      let all_classes = this.$echarts.init(
        document.getElementById("Pie_chart")
      ); // 类柱状图
      let all_states = this.$echarts.init(document.getElementById("Funnel")); // 销售流程漏斗图

      all_instruments.setOption({
        // 仪表
        tooltip: {
          formatter: function (value) {
            return (
              value.seriesName +
              ": " +
              value.data.target_money +
              "<br/> 完成金额：" +
              value.data.finish_money +
              "(" +
              value.data.value +
              "%)"
            );
          },
        },
        series: [
          {
            data: [this.whole_myChart_data],
            axisLine: {
              //仪表盘轴线
              lineStyle: {
                //轴线不同的颜色段
                // color: [[0.2,'#00FFFF'],[0.8,'#3a80fa'],[1,'#ff0000']],
                width: 20, //轴线宽度
              },
            },
            name: "业绩指标",
            max: "100",
            type: "gauge",
            detail: {
              offsetCenter: ["0", "90"],
              formatter: function (val) {
                // console.log('手册', val)
                return that.whole_myChart_data.finish_money;
              },
              // color: '#ffd805',
              fontSize: 30,
              fontWeight: "bold",
              //相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移
              // offsetCenter: [0, '75%']
            },
          },
        ],
      });
      all_classes.setOption({
        // 柱状图
        tooltip: {
          formatter: function (value) {
            return value.name + ": " + value.data;
          },
        },
        xAxis: {
          // show : false,
          type: "category",
          data: [
            this.whole_Pie_chart_data[0].name,
            this.whole_Pie_chart_data[1].name,
            this.whole_Pie_chart_data[2].name,
            this.whole_Pie_chart_data[3].name,
          ],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#bbb",
            },
          },
        },
        yAxis: {
          show: false,
          type: "value",
        },
        color: "#6395F9",
        series: [
          {
            data: [
              this.whole_Pie_chart_data[0].value,
              this.whole_Pie_chart_data[1].value,
              this.whole_Pie_chart_data[2].value,
              this.whole_Pie_chart_data[3].value,
            ],
            type: "bar",
            barWidth: 20, //柱图宽度
            showBackground: true,
            backgroundStyle: {
              color: "rgba(225, 225, 225, 0.9)",
              // color: '#6395F9'
            },
            itemStyle: {
              //             normal: {
              // 　　　　　　　　//这里是重点
              //                 color: function(params) {
              //                     //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
              //                     var colorList = ['#a5e7f0', '#59c4e6', '#edafda', '#93b7e3'];
              //                     return colorList[params.dataIndex]
              //                 }
              //             }
            },
          },
        ],
      });
      all_states.setOption({
        // 漏斗图
        tooltip: {
          trigger: "item",
          formatter: function (value) {
            return value.name + ": " + value.data.value;
          },
        },

        series: [
          {
            name: "",
            type: "funnel",
            left: "10%",
            top: 60,
            //x2: 80,
            bottom: 60,
            width: "80%",
            // height: {totalHeight} - y - y2,
            // min: 0,
            // max: 500,
            minSize: "0%",
            maxSize: "100%",
            sort: "descending",
            gap: 2,
            label: {
              show: true,
              position: "inside",
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            // itemStyle: {
            //     borderColor: '#fff',
            //     borderWidth: 1
            // },
            // emphasis: {
            //     label: {
            //         fontSize: 20
            //     }
            // },
            data: that.whole_sales_process_status,
          },
        ],
      });
      this.whole_sales_process_status.forEach((item, index) => {
        // 流程小折线图
        let name = "Line" + index;
        window[name] = this.$echarts.init(
          document.getElementById("Line" + index + "")
        ); // 线状图
        window[name].setOption({
          xAxis: {
            show: false,
            boundaryGap: false,
            type: "category",
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            show: false,
            // type: 'value'
          },
          color: "#99CCFF",
          series: [
            {
              showSymbol: false,
              data: that.whole_sales_process_status["" + index + ""].sevenday,
              type: "line",
              smooth: true,
              areaStyle: {},
            },
          ],
        });
      });
      this.whole_every_day.forEach((item, index) => {
        let name = "every_day" + index;
        window[name] = this.$echarts.init(
          document.getElementById("every_day" + index + "")
        ); // 线状图
        window[name].setOption({
          xAxis: {
            show: false,
            boundaryGap: false,
            type: "category",
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            show: false,
            // type: 'value'
          },
          color: "#99CCFF",
          series: [
            {
              showSymbol: false,
              data: that.whole_every_day["" + index + ""].sevenday,
              type: "line",
              smooth: true,
              areaStyle: {},
            },
          ],
        });
      });
    },
    all_exhibition() {
      let that = this;
      let all_exhibition = this.$echarts.init(
        document.getElementById("total_Line_chart")
      ); // 销售流程折线图图
      all_exhibition.setOption({
        // title: {
        //     text: '三十天的走势图'
        // },
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //     data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
        // },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
            20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
          ],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "最佳",
            type: "line",
            stack: "总量",
            data: this.whole_Trend_chart_data.best_month_data,
          },
          {
            name: "上月",
            type: "line",
            stack: "总量",
            data: this.whole_Trend_chart_data.last_month_data,
          },
          {
            name: "本月",
            type: "line",
            stack: "总量",
            data: this.whole_Trend_chart_data.this_month_data,
          },
        ],
      });
    },

    require_ech() {
      this.sale_data_show(); // 仪表盘信息
      this.client_sort_count(); // ABCD类数据
      // this.trend_broken_line(); // 走势折线图
      this.telephone_calls(); // 基础工作电话情况
      this.process_status(); // 销售流程状态下的客户
      this.performance_data(); // 职员趋势图
      this.per_person_per_day(); // 每人每天
      this.follow_data_re();
    },
    whole_require_ech() {
      // myChart_loading: false,
      // Pie_chart_loading: false,
      // broken_line_loading: false,
      // Line_loading: false,
      // every_day_loading: false,
      this.myChart_loading = true;
      this.Pie_chart_loading = true;
      this.broken_line_loading = true;
      this.telephone_calls_loading = true;
      this.Line_loading = true;
      this.every_day_loading = true;
      require("POST", "/lufish_index_data/v1/show_all_data/", {}).then(
        (res) => {
          console.log("内容", res);
          let that = this;
          if (!res.code) {
            res.data.target_data.name = "完成金额";
            this.whole_myChart_data = res.data.target_data;
            this.whole_Pie_chart_data = res.data.client_sort_data;
            this.whole_sales_process_status = res.data.follow_status;
            this.whole_every_day = res.data.today_create_data;

            this.all_employee_data();

            this.myChart_loading = false;
            this.Pie_chart_loading = false;
            this.broken_line_loading = false;
            this.telephone_calls_loading = false;
            this.Line_loading = false;
            this.every_day_loading = false;
          } else {
            this.$message.error("全部数据获取失败");
          }
        }
      );
    },
    handleClick(e) {
      // 职员切换
      this.$cookies.set("staff_id", e);
      this.require_ech();
    },
    handleChange(e) {
      if (e[0] == "S7A40A0BC9" || e[0] == "渠道") {
        this.is_show_yibiaopan = true;
      } else {
        this.is_show_yibiaopan = false;
      }
      this.$cookies.set("staff_id", e);
      console.log("内容=--->", this.$cookies.get("staff_id").split(","));

      // this.$cookies.set("quanxian", e);
      this.require_ech();
    },
    handleClick_item() {},
  },
  watch: {},
};
</script>
<style scoped>
.manager_cenetr {
  /* background: white; */
  display: flex;
  justify-content: space-between;
  /* justify-content: space-around; */
  flex-wrap: wrap;
}
.item_range_index {
  /* border: 1px red solid; */
  border-radius: 10px;
  background: white;
  min-height: 250px;
  margin: 14px;
  padding: 4px 10px;
  /* box-shadow: 6px 6px 20px #888888; */
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
}
.flex_work {
  background: white;
  min-height: 250px;
  margin: 14px;
  padding: 4px 10px;
}
.Icon_div {
  margin: 6px auto;
}
.right_button {
  border-left: 1px #ccc solid;
  padding: 10px 20px;
  width: 400px;
}
.button_right_f {
  margin: 6px 0;
  width: 100px;
  font-size: 14px;
}
.data_overview_title {
  font-size: 17px;
  padding: 5px 0;
  padding-left: 30px;
}
.data_overview_text {
  font-size: 14px;
}
.for_map {
  padding: 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}
.data_map {
  /* border:1px red solid; */
  width: 280px;
  padding: 20px;
  margin: 10px auto;
  box-sizing: border-box;
}
.data_map p {
  color: #aaa;
  font-size: 14px;
  margin: 5px 0;
  margin-bottom: 30px;
}
.shujv_span {
  /* border:1px red solid; */
  font-weight: 700;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: space-between;
}
.line_chart {
  /* border: 1px red solid; */
  margin: 15px 0 0 0;
  height: 80px;
}
.open {
  border-top: 1px #ededed solid;
  padding: 10px 0;
  text-align: center;
  font-size: 14px;
  color: cornflowerblue;
}
.open span:hover {
  cursor: pointer;
}

.choose {
  width: 500px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex_div_over {
  display: flex;
  justify-content: space-between;
}
.bottom_message {
  /* margin-top:-20px; */
  text-align: center;
  color: #aaa;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/me_data.vue